import { render, staticRenderFns } from "./back-to-top.vue?vue&type=template&id=d3d4bfa6"
import script from "./back-to-top.vue?vue&type=script&lang=js"
export * from "./back-to-top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@2.1.1_webpack@4.47.0__lodash@4.17.21_vu_3eef67c0e1ef2ea3d089dafcd6c47d43/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/phuongle/Documents/MAV/deploy 1001/1001-optical-astro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3d4bfa6')) {
      api.createRecord('d3d4bfa6', component.options)
    } else {
      api.reload('d3d4bfa6', component.options)
    }
    module.hot.accept("./back-to-top.vue?vue&type=template&id=d3d4bfa6", function () {
      api.rerender('d3d4bfa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/back-to-top.vue"
export default component.exports